import { h, Component } from 'preact'
import {emojify} from 'react-emojione-preact'
import Button from '../forms/Button'
import Input from '../forms/Input'
import Checkbox from '../forms/Checkbox'
import Icon from '../Icon'
import HScroll from '../HScroll'
import style from './styles/answer.scss'

import {names} from './data/names'

const nameGenerator = (gender) => names[gender][Math.round(Math.random()*(names[gender].length-1))]

class Answer extends Component {
  showButtons(answers, question) {
    return <HScroll key={question}>
      {answers.map(a => (<Button onClick={this.handleAnswer} value={a.id}>
        {emojify(a.title, {style: {height: 16}})}
      </Button>))}
    </HScroll>
  }

  showInput(question, format, placeholder) {
    return <Input key={question} type="form" format={format} placeholder={placeholder} onSubmit={this.handleAnswer} />
  }

  showMultiple(answers, question) {
    return <Checkbox key={question} answers={answers} onChecked={this.handleAnswer} />
  }

  showContent() {
    const {answers, type, question, format, placeholder, isTyping} = this.props
    switch(type) {
      case 'button':
        return this.showButtons(answers, question)
      case 'input':
        return !isTyping ? this.showInput(question, format, placeholder) : null
      case 'multiple':
        return this.showMultiple(answers, question)
      default:
        return 'Неизвестный тип'
    }
  }

  handleAnswer = (value) => {
    const {question, onAnswer} = this.props
    onAnswer(question, value)
  }

  render({type, isTyping}) {
    return (
      <div class={`${style[type]} ${isTyping ? style.hidden : ''}`}>
        {this.showContent()}
      </div>
    )
  }
}

export default Answer



// WEBPACK FOOTER //
// ./components/ChatBot/Answer.js